export const parseStepSearchParam = (stepParam: string | null) => {
  if (!stepParam || !/^\d+$/.test(stepParam)) {
    return 0;
  }

  return Number.parseInt(stepParam, 10);
};
